export default __webpack_public_path__ + "static/media/Barbs of Persuasion.582e3aab.jpg";